import React from "react";
import { Alert, Typography, useTheme } from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";

const CheckNotRunAlert = () => {
  const theme = useTheme();

  return (
    <Alert
      severity="info"
      icon={<InfoIcon sx={{ fontSize: 20 }} />}
      sx={{
        borderRadius: "12px",
        backgroundColor: theme.customColors?.background?.info || "#EFF6FF",
        border: `1.5px solid ${theme.customColors?.status?.info?.main || "#3B82F6"}50`,
        boxShadow: "0 2px 8px rgba(59, 130, 246, 0.12)",
        py: 1,
        px: 3.5,
        "& .MuiAlert-icon": {
          color: theme.customColors?.status?.info?.main || "#3B82F6",
          alignSelf: "flex-start",
          mt: 0.25,
          mr: 1.5,
        },
        "& .MuiAlert-message": {
          color: theme.customColors?.text?.primary || "#111827",
          width: "100%",
          padding: 0,
          display: "flex",
          alignItems: "center",
        },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.9375rem",
          fontWeight: 500,
          color: theme.customColors?.text?.primary || "#111827",
          lineHeight: 1.7,
        }}
      >
        This check hasn't been run yet. Trigger the check to view resources if available for this check.
      </Typography>
    </Alert>
  );
};

export default CheckNotRunAlert;
